export default __webpack_public_path__ + "static/media/linkedin.a809d587.svg";